var _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClosePopUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.51739,
    y1: 23.1248,
    x2: 23.3518,
    y2: 2.29042,
    stroke: "#174374",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.76777,
    y1: 2.23223,
    x2: 22.6022,
    y2: 23.0666,
    stroke: "#174374",
    strokeWidth: 5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePopUp);
export default __webpack_public_path__ + "static/media/closePopUp.d2560d32bd835aff25aabeff7a98ed1d.svg";
export { ForwardRef as ReactComponent };